export default "__VITE_ASSET__JeKFkaiU__"